import React from 'react';

class InfluenceAnswers extends React.Component {

    render() {
        const {
            answers, questionNumber, handleChange
        } = this.props;
        return (
            <ul className="toch-survey__radio-list">
                {answers.map((answer) => {
                    return (
                        <li key={questionNumber + answer.text}>                            
                            <div className="toch-survey__radio">
                                <input type="radio"
                                    value={answer.text}
                                    id={questionNumber + answer.text}
                                    name={"toch-survey__radio-" + questionNumber} 
                                    onChange={(e) => handleChange(questionNumber, e, null)}
                                ></input>
                                <label
                                    htmlFor={questionNumber + answer.text}
                                    className="toch-survey__label">{answer.text}</label>
                            </div>
                        </li >
                    );
                })
                }
            </ul >
        );
    }
}

export default InfluenceAnswers;
